module.exports = __webpack_public_path__ + "static/media/verify.f34afe15.png";